import { render } from "./MenuLogado.vue?vue&type=template&id=35eb3b9e"
const script = {}
script.render = render

export default script